import { useEffect, useState } from "react";

export default function useJsonStore(){

    const [data, setData] = useState(jsonStore)

    useEffect(() => {

        setData(jsonStore);

    }, [])

    return data;
}


/**
 * Object that can access the session storage item "jsonStore"
 * @var object 
 */
const jsonStore = {

        
    /**
     * Retrieve all data from session storage item named "jsonStore"
     * @return {*}
     */
    getData(){
        try{
            let store = window.localStorage.getItem('jsonStore');
            let data = JSON.parse(store);

            return (typeof data === 'object' && !Array.isArray(data) && data !== null) ? data : {};

        }catch(e){
            window.localStorage.removeItem('jsonStore');
            return {};
        }
    },


    /** 
     * Returns true if param is stored
     * @param string paramName
     * @returns bool
     **/
    has(paramName){
        let data = this.getData();
        return data[paramName] ? true : false;
    },


    /** 
     * Retrieve data by param name 
     * @param string paramName
     * @returns {*}
     **/
    get(paramName){
        let data = this.getData();
        return data[paramName];
    },


    /**
     * Set data indexed by param name
     * @param string paramName
     * @param {*} value 
     * @returns this
     */
    set(paramName, value){
        let data = this.getData();
        data[paramName] = value;
        window.localStorage.setItem('jsonStore', JSON.stringify(data));
        return this;
    },

    /**
     * Remove data by param name
     * @param string paramName
     * @returns this
     */
    remove(paramName){
        let data = this.getData();
        delete data[paramName];
        window.localStorage.setItem('jsonStore', JSON.stringify(data));
        return this;
    },
}